// extracted by mini-css-extract-plugin
export default {"scenario":"EditableScenario_scenario__T2wdM"};